import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ITEMS_PER_PAGE = 10;

export default function RecentCaptures() {
  const [captures, setCaptures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetch('https://api.nxtrp.pl/api/captures')
      .then(res => res.json())
      .then(data => {
        setCaptures(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div>Ładowanie…</div>;
  if (!captures.length) return <div>Brak danych.</div>;

  // Paginacja
  const totalPages = Math.ceil(captures.length / ITEMS_PER_PAGE);
  const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIdx = startIdx + ITEMS_PER_PAGE;
  const pageData = captures.slice(startIdx, endIdx);

  return (
    <div>
      <h2>Ostatnie przejęcia</h2>
      <table>
        <thead>
          <tr>
            <th>Strefa</th>
            <th>Organizacja</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {pageData.map((c, i) => (
            <tr key={startIdx + i}>
              <td>
                <Link to={`/strefa/${encodeURIComponent(c.zone)}`}>{c.zone}</Link>
              </td>
              <td style={{ color: c.success === 1 ? "#16a34a" : "#be123c" }}>
                {c.by} {c.success === 1 ? "✔️" : "❌"}
              </td>
              <td>{c.at}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16, marginTop: 18 }}>
        <button className="button" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>&larr; Poprzednia</button>
        <span style={{ margin: '0 12px', color: '#e43c92', fontWeight: 600 }}>
          Strona {currentPage} z {totalPages}
        </span>
        <button className="button" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>Następna &rarr;</button>
      </div>
    </div>
  );
}
